module.exports = __webpack_public_path__ + "img/logo-white-bg.6d76faf8.svg";